<template>
  <div data-app>
    <b-alert :show="successAlert.show" variant="success">
      {{ successAlert.text }}
    </b-alert>
    <b-alert :show="warningAlert.show" variant="danger">
      {{ warningAlert.text }}
    </b-alert>
    <v-card>
      <v-card-title>
        Countries
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="search"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="collection"
        :search="search"
        :sort-by="['name']"
        @click:row="handleClickItem"
      >
        <template v-slot:top>
          <v-toolbar flat>
            <!-- <v-toolbar-title>My CRUD</v-toolbar-title> -->
            <!-- <v-divider class="mx-4" inset vertical></v-divider> -->
            <!-- <v-spacer></v-spacer> -->
            <v-checkbox v-model="showAll" label="Active countries"></v-checkbox>
            <!-- <v-spacer></v-spacer> -->
            <CountryModalForm
              :loader="loader"
              :modalData="modalData"
              :permissions="permissions"
              :messages="messages"
              :selectedLocale="selectedLocale"
              @closeModalForm="handleCloseModalForm"
              @saveModalForm="handleSaveModalForm"
              @resetErrorData="handleResetErrorData"
            ></CountryModalForm>
            <v-dialog v-model="dialogDelete" max-width="500px">
              <v-card>
                <v-card-title class="headline"
                  >Are you sure you want to delete this item?</v-card-title
                >
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" text @click="closeDelete"
                    >Cancel</v-btn
                  >
                  <v-btn color="blue darken-1" text @click="deleteItemConfirm"
                    >OK</v-btn
                  >
                  <v-spacer></v-spacer>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-toolbar>
        </template>
        <template v-slot:item.eu="{ item }">
          {{ eu[item.eu] }}
        </template>
        <template v-slot:item.actions="{ item }">
          <!-- <router-link
            :to="`/settings/country/${item.id}`"
            v-if="permissionCan('view')"
          >
            <v-icon small class="mr-2"> mdi-pencil </v-icon>
          </router-link> -->
          <!-- <v-icon small @click="deleteItem(item)"> mdi-delete </v-icon> -->
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import ApiService from "@/core/services/api.service";
import CountryModalForm, { initialFormData } from "./CountryModalForm";
import i18nService from "@/core/services/i18n.service.js";

import { COUNTRY_ALL_COLLECTION } from "@/core/services/store/country.module.js";

export default {
  name: "Country",
  components: { CountryModalForm },
  data() {
    return {
      selectedLocale: i18nService.languages.find((item) => {
        return item.lang == i18nService.getActiveLanguage();
      }),
      errors: [],
      messages: {},
      loader: false,
      showAll: true,
      search: "",
      collection: [],
      permissions: [],
      eu: ["no", "yes"],
      successAlert: {
        show: false,
        text: "Success alert!",
      },
      warningAlert: {
        show: false,
        text: "Warning alert!",
      },
      headers: [
        {
          text: "ID",
          align: "left",
          sortable: false,
          value: "id",
        },
        {
          text: "Country",
          value: "name",
        },
        {
          text: "Language",
          value: "locale",
        },
        {
          text: "Currency",
          value: "currency_id",
        },
        {
          text: "EU",
          value: "eu",
        },
        // { text: "Actions", value: "actions", sortable: false },
      ],

      modalData: {
        dialog: false,
        editedIndex: -1,
        editedItem: {
          id: "",
          locale: "",
          eu: 1,
          currency_id: "EUR",
          translations: {
            en: { name: "" },
            hu: { name: "" },
          },
        },
        defaultItem: initialFormData,
      },

      dialogDelete: false,
    };
  },

  computed: {
    ...mapGetters([COUNTRY_ALL_COLLECTION]),
  },

  watch: {
    dialogDelete(val) {
      val || this.closeDelete();
    },
    showAll() {
      if (this[COUNTRY_ALL_COLLECTION].length > 0) {
        this.filterCollection(this[COUNTRY_ALL_COLLECTION]);
      }
    },
    "$route.params.id": {
      handler: function (id) {
        if (id) {
          this.editItem(id);
        }
      },
      deep: true,
      immediate: true,
    },
    countryAllCollection(val) {
      // this.collection = val;
      this.filterCollection(val);
    },
  },

  methods: {
    ...mapActions(["fetchAllCountry"]),
    editItem(id) {
      ApiService.get("country/" + id)
        .then(({ data }) => {
          this.modalData.editedIndex = 1;
          this.modalData.editedItem = Object.assign({}, data);
          this.modalData.dialog = true;
        })
        .catch((error) => {
          console.log("Error!: ", error);
        });
    },

    deleteItem(item) {
      this.editedIndex = this[COUNTRY_ALL_COLLECTION].indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },

    deleteItemConfirm() {
      ApiService.delete("country/" + this.editedItem.id)
        .then(() => {
          this.fetchAllCountry();
        })
        .catch((error) => {
          console.log("Error!: ", error);
        });
      this.closeDelete();
    },

    handleCloseModalForm() {
      this.modalData.dialog = false;
      this.modalData.editedIndex = -1;
      this.modalData.editedItem = this.modalData.defaultItem;
      this.selectedLocale = i18nService.languages.find((item) => {
        return item.lang == i18nService.getActiveLanguage();
      });
      if (this.$route.name !== "country")
        this.$router.push({ name: "country" });
      // this.$router.push({ name: "country" });
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    setError(prop, value) {
      if (prop.search("translations.") != -1) {
        let langCode = prop.replace("translations.", "").substring(0, 2);

        this.selectedLocale = i18nService.languages.find((item) => {
          return item.lang == langCode;
        });
      }
      console.log(this.selectedLocale);
      this.messages[prop] = value;
    },

    handleSaveModalForm(model) {
      this.loader = true;
      if (this.modalData.editedIndex > -1) {
        ApiService.put("country/" + model.id, model)
          .then(() => {
            this.fetchAllCountry();
            this.handleCloseModalForm();
          })
          .catch((error) => {
            this.warningAlert.text = error.message;
            this.warningAlert.show = true;
            console.log("Error!: ", error);
            if (error.response) {
              let errors = error.response.data;
              if (errors) {
                for (let field in errors) {
                  this.setError(field, errors[field][0]);
                }
              }
            }
          })
          .finally(() => {
            this.loader = false;
          });
      } else {
        //create model
        ApiService.post("country", model)
          .then(({ data }) => {
            console.log(data);
            this.fetchAllCountry();
            this.handleCloseModalForm();
          })
          .catch((error) => {
            console.log("Error!: ", error);
            if (error.response) {
              let errors = error.response.data;
              if (errors) {
                for (let field in errors) {
                  this.setError(field, errors[field][0]);
                }
              }
            }
          })
          .finally(() => {
            this.loader = false;
          });
      }
    },

    handleResetErrorData(data) {
      this.messages[data] = "";
    },

    handleClickItem(item) {
      if (this.permissionCan("view") && !this.dialogDelete) {
        this.$router.push(`/settings/country/${item.id}`);
      }
    },

    filterCollection(coll) {
      if (!this.showAll) {
        this.collection = coll;
      } else {
        this.collection = coll.filter((item) => {
          return item.status == 1;
        });
      }
    },
    permissionCan(action) {
      return this.permissions.find((x) => x.name == "system.country." + action);
    },
    setPermissions() {
      if (localStorage.permissions) {
        this.permissions = JSON.parse(localStorage.permissions).filter(
          (item) => item.name.indexOf("country") > -1
        );
      }
    },
  },

  async mounted() {
    this.fetchAllCountry();
    this.setPermissions();
  },
};
</script>
